import { useContext } from 'react';
import classNames from 'classnames';
import {status} from 'hooks/useNotificationsStore';
import SessionContext from 'SessionContext'
import { Button } from 'reactstrap';

const statusIcon = {
  [status.error]: 'status-error fa fa-xmark-circle',
  [status.working]: 'status-working fa-solid fa-rotate',
  [status.waiting]: 'status-waiting fa fa-circle-pause',
  [status.complete]: 'status-complete fa fa-circle-check'
};

const Notifications = () => {
  const context = useContext(SessionContext);

  function onMouseLeave(){
    if (context.notificationsStore.unread() > 0) {
      context.notificationsStore.markRead();
    }
  }

  function clear() {
    context.notificationsStore.clear();
  }

  const notifications = context.notificationsStore.notifications();
  if(notifications.length === 0) return <></>;

  const statuses = notifications.map((n)=> n.status);
  const mainStatus = Math.min(...statuses);
  const percentages = notifications.map((n)=> n.percent);
  const mainPercent = Math.min(...percentages);

  return (
    <div className='notifications' onMouseLeave={onMouseLeave}>
      <div className='main-icon working'>
        Notifications&nbsp;{(context.notificationsStore.unread() > 0) && <>({context.notificationsStore.unread()} new)</>}&nbsp;
        <i className={classNames('status-icon', statusIcon[mainStatus])} />
        {mainPercent > 0 && mainPercent < 100 &&
          <span className='main-percent'>{mainPercent}</span>}
      </div>
      <ul>
        {notifications.map( (note, i)=>
          <li key={i}>
            <i className={classNames('status-icon', statusIcon[note.status])} />
            <div className='content'>
              <span className='title'>{note.title}</span>
              <span className='details'>{note.details}</span>
              {note.percent &&
                <span className='percent'>{note.percent}%</span>}
            </div>
          </li>
        )}
        <div align={'center'}><Button onClick={clear}>Clear</Button></div>
      </ul>

    </div>
  );
}
export default Notifications;
